import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data.user);
        const target = res.data.user.role === "admin" ? "/admin" : "/dashboard";
        window.history.replaceState(null, "", window.location.pathname);
        navigate(target, { replace: true, state: { user: res.data.user } });
      } catch (error) {
        console.error("Auth callback error:", error);
        const reason = error.response?.data?.detail || "Innlogging feilet";
        window.history.replaceState(null, "", window.location.pathname);
        navigate(`/?error=${encodeURIComponent(reason)}`, { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-sm uppercase tracking-widest text-neutral-500">Logger inn…</div>
    </div>
  );
}
